import React from 'react';
import styled from 'styled-components';
import { memData } from '../../utils/memData';
const TeamBox = () => {
  return (
    <TeamBoxWrapper>
      {memData &&
        memData.map((mem) => (
          <div className="mems" key={mem.id}>
            <div className="mem-box">
              <div className="overlay">
                <div className="info">
                  <h4>{mem.expert}</h4>
                  <h2>{mem.memName}</h2>
                  <small>{mem.poss}</small>
                </div>
                <div className="socials">
                  <span>
                    {mem.fb}
                    {mem.ig}
                    {mem.tw}
                    {mem.lIn}
                  </span>
                </div>
              </div>
              <div className="img">
                <img src={mem.imgSrc} alt="mem-avatar" />
              </div>
            </div>
          </div>
        ))}
    </TeamBoxWrapper>
  );
};

const TeamBoxWrapper = styled.article`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  place-items: center;
  margin-top: 3%;
  .mems {
    width: 100%;
    .mem-box {
      position: relative;
      cursor: pointer;
      width: 100%;
      img {
        width: 100%;
        border: 6px solid var(--bg-color);
        border-radius: 0.2rem;
      }

      &:hover {
        .overlay {
          opacity: 1;
          visibility: visible;
        }
      }
      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to bottom left,
          var(--ico-color) 10%,
          var(--bg-color) 90%
        );
        border-radius: 0.2rem;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        opacity: 0;
        visibility: hidden;
        transition: all 2s ease-in-out;
        transform-origin: center left;

        .info {
          height: 60%;
          width: 100%;
          color: var(--main-color);
          text-shadow: 0 0 10px var(--bg-color);
          letter-spacing: 1.3px;
          h2 {
            padding: 15px 0;
            font-size: 1.4rem;
            font-weight: 700;
          }
          h4 {
            font-size: 20px;
          }

          small {
            font-size: 20px;
            font-weight: 800;
          }
        }

        .socials {
          span {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1.5rem;

            .m-ico {
              width: 45px;
              height: 45px;
              background: var(--main-color);
              box-shadow: 0 0 10px var(--bga-color);
              color: var(--bg-color);
              border-radius: 0.5rem;
              font-size: 25px;
              padding: 10px;
              transition: all 600ms ease-in-out;

              &:active {
                transform: scale(0.9);
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 884px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 430px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default TeamBox;
